export default __webpack_public_path__ + "static/media/logo3.d74c6abf.png";